/* LV 23.09.2026: wyszukiwarka w menu burger filtruje POZYCJE MENU (nie produkty).
   Wpisywanie od razu pokazuje pasujace zakladki i podzakladki zamiast listy menu;
   wyczyszczenie pola przywraca zwykle menu. Enter wchodzi w pierwszy wynik. */
(function () {
  function bezOgonkow(t) {
    return (t || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/ł/g, 'l');
  }

  function start() {
    var form = document.querySelector('.lv-menu-szukaj');
    var nav = document.querySelector('.menu-drawer__navigation');
    if (!form || !nav || form.dataset.lvGotowe) return;
    var pole = form.querySelector('input[type="search"]');
    if (!pole) return;
    form.dataset.lvGotowe = '1';

    var wyniki = document.createElement('ul');
    wyniki.className = 'lv-menu-wyniki list-unstyled';
    wyniki.hidden = true;
    nav.parentNode.insertBefore(wyniki, nav.nextSibling);

    var indeks = null;

    function zbudujIndeks() {
      indeks = [];
      nav.querySelectorAll('a[href]').forEach(function (a) {
        var href = a.getAttribute('href') || '';
        if (!href || href.charAt(0) === '#') return;
        if (a.classList.contains('lv-menu-wszystko')) return;
        var etykieta = (a.textContent || '').replace(/\s+/g, ' ').trim();
        if (!etykieta || etykieta.toLowerCase() === 'line') return;
        var sciezka = [];
        var el = a.parentElement;
        while (el && el !== nav) {
          if (el.tagName === 'DETAILS') {
            var s = el.querySelector('summary .menu-drawer__menu-item');
            if (s) {
              var t = (s.textContent || '').replace(/\s+/g, ' ').trim();
              if (t && sciezka.indexOf(t) === -1) sciezka.unshift(t);
            }
          }
          el = el.parentElement;
        }
        indeks.push({ etykieta: etykieta, href: href, sciezka: sciezka.join(' › ') });
      });
    }

    function pokaz(fraza) {
      if (!indeks) zbudujIndeks();
      var s = bezOgonkow(fraza);
      var trafienia = indeks
        .filter(function (p) {
          return bezOgonkow(p.etykieta).indexOf(s) > -1;
        })
        .slice(0, 15);

      wyniki.innerHTML = '';
      if (!trafienia.length) {
        var pusty = document.createElement('li');
        pusty.className = 'lv-menu-wyniki__pusto';
        pusty.textContent = 'Brak pasujących zakładek';
        wyniki.appendChild(pusty);
      } else {
        trafienia.forEach(function (p) {
          var li = document.createElement('li');
          var a = document.createElement('a');
          a.href = p.href;
          a.className = 'lv-menu-wyniki__pozycja';
          a.textContent = p.etykieta;
          if (p.sciezka) {
            var sp = document.createElement('span');
            sp.className = 'lv-menu-wyniki__sciezka';
            sp.textContent = p.sciezka;
            a.appendChild(sp);
          }
          li.appendChild(a);
          wyniki.appendChild(li);
        });
      }
      wyniki.hidden = false;
      nav.hidden = true;
    }

    function schowaj() {
      wyniki.hidden = true;
      wyniki.innerHTML = '';
      nav.hidden = false;
    }

    var czekaj;
    pole.addEventListener('input', function () {
      clearTimeout(czekaj);
      czekaj = setTimeout(function () {
        var q = pole.value.trim();
        if (q.length < 2) schowaj();
        else pokaz(q);
      }, 120);
    });

    pole.addEventListener('search', function () {
      if (!pole.value.trim()) schowaj();
    });

    // wyszukiwarka dotyczy tylko menu, wiec Enter nie wysyla formularza do /search
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var pierwszy = wyniki.querySelector('a');
      if (pierwszy) pierwszy.click();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
